module.exports = __webpack_public_path__ + "static/media/KFOmCnqEu92Fr1Mu72xKKTU1Kvnz.80ea3224.woff2";